/**
 * Punto de entrada de la Suite (decision de arquitectura, oct-2026):
 *
 *  - Despues de iniciar sesion, y cada vez que alguien ENTRA de nuevo a LCC (pestaña o
 *    ventana nueva, app instalada, URL escrita o autocompletada por el navegador), se
 *    llega al Menu de aplicaciones ("/"), nunca a la ultima pantalla que tuvo abierta.
 *    Antes, si el navegador autocompletaba lcc-web.pages.dev/tiempos, el administrador
 *    caia en Tiempos Operativos aunque viniera de TurnoGeo.
 *  - Dentro de la MISMA pestaña se respeta la ruta (F5 / recargar no lo saca de donde esta).
 *  - La ultima aplicacion usada se recuerda solo como ATAJO en el menu ("Continuar en ..."),
 *    no como redireccion automatica.
 */
const ENTRY_KEY = 'lcc.session.entered';
const LAST_APP_KEY = 'lcc.lastApplication';

/** URLs propias del flujo de inicio de sesion de Clerk que no se deben tocar. */
function isAuthFlowUrl(loc: Location): boolean {
  return /__clerk|sso-callback|verify|factor-two|reset-password/i.test(loc.search + loc.hash);
}

function sendToMenu(): void {
  if (window.location.pathname !== '/') window.history.replaceState(null, '', '/');
}

/** Se llama UNA vez al arrancar, antes de montar el router. */
export function applyEntryRedirect(): void {
  try {
    if (sessionStorage.getItem(ENTRY_KEY)) return; // misma pestaña: se respeta la ruta (recargar)
    sessionStorage.setItem(ENTRY_KEY, '1');
    if (!isAuthFlowUrl(window.location)) sendToMenu();
  } catch {
    /* sin sessionStorage (modo privado estricto): se deja la ruta tal cual */
  }
}

/** Justo despues de un inicio de sesion exitoso: siempre al menu de aplicaciones. */
export function redirectToMenuAfterSignIn(): void {
  try {
    sessionStorage.setItem(ENTRY_KEY, '1');
  } catch {
    /* ignorar */
  }
  sendToMenu();
}

export function rememberLastApplication(code: string): void {
  try {
    localStorage.setItem(LAST_APP_KEY, code);
  } catch {
    /* ignorar */
  }
}

export function getLastApplication(): string | null {
  try {
    return localStorage.getItem(LAST_APP_KEY);
  } catch {
    return null;
  }
}
